import { CSSProperties, ReactNode } from 'react'
import { Button, CircularProgress } from '@mui/material'
import styles from './Footer.module.scss'
//import { default as Logo } from '../images/kiro-logo.svg'

interface FooterProps {
  buttonId?: string
  buttonText: string
  buttonType?: any
  onButtonClick?: () => void | undefined
  isLoading: boolean
  isDisabled: boolean
  showButton?: boolean
  shouldShowFour?: boolean
  shouldShowSix?: boolean
  shouldShowFive?: boolean
  shouldShowSeven?: boolean
  shouldShowEight?: boolean
  trackerIndex: number
  style?: CSSProperties
  showHelpSmsLink?: boolean
  aboveButtons?: ReactNode
  secondaryButtonText?: string
  secondaryButtonId?: string
  onSecondaryButtonClick?: () => void
}

const HELP_SMS_NUMBER = '+16468464042'

export default function Footer({
  buttonText,
  buttonId,
  buttonType,
  onButtonClick,
  isDisabled,
  isLoading,
  showButton = true,
  trackerIndex,
  shouldShowFour,
  shouldShowFive,
  shouldShowSix,
  shouldShowSeven,
  shouldShowEight,
  style,
  showHelpSmsLink,
  aboveButtons,
  secondaryButtonText,
  secondaryButtonId,
  onSecondaryButtonClick,
}: FooterProps) {
  return (
    <div className={styles.footer} style={style}>
      {trackerIndex !== 0 && (
        <div className={trackerIndex === 10 ? styles.disableTracker : styles.trackerContainer}>
          <div className={trackerIndex >= 1 ? styles.activeStep : styles.inactiveStep}></div>
          <div className={trackerIndex >= 2 ? styles.activeStep : styles.inactiveStep}></div>
          <div className={trackerIndex >= 3 ? styles.activeStep : styles.inactiveStep}></div>
          {/* <div className={trackerIndex >= 4 ? styles.activeStep : styles.inactiveStep}></div> */}
          {shouldShowFour && <div className={trackerIndex >= 4 ? styles.activeStep : styles.inactiveStep}></div>}
          {shouldShowFive && <div className={trackerIndex >= 5 ? styles.activeStep : styles.inactiveStep}></div>}
          {shouldShowSix && <div className={trackerIndex >= 6 ? styles.activeStep : styles.inactiveStep}></div>}
          {shouldShowSeven && <div className={trackerIndex >= 7 ? styles.activeStep : styles.inactiveStep}></div>}
          {shouldShowEight && <div className={trackerIndex >= 8 ? styles.activeStep : styles.inactiveStep}></div>}
        </div>
      )}
      {aboveButtons}
      {secondaryButtonText && (
        <Button
          id={secondaryButtonId ? secondaryButtonId : ''}
          className={styles.secondaryButton}
          type={'button'}
          onClick={onSecondaryButtonClick}
          style={{ width: '97%' }}
        >
          {secondaryButtonText}
        </Button>
      )}
      {showButton && (
        <Button
          id={buttonId ? buttonId : ''}
          className={isDisabled ? styles.disabledButton : styles.button}
          sx={{}}
          type={buttonType ? buttonType : 'button'}
          onClick={onButtonClick}
          style={{ width: '97%' }}
        >
          {!isLoading && buttonText}
          {isLoading && (
            <CircularProgress
              size={20}
              sx={{
                color: 'white',
                width: '14px',
                height: '14px',
                left: '90%',
              }}
            />
          )}
        </Button>
      )}
      {showHelpSmsLink && (
        <a href={`sms:${HELP_SMS_NUMBER}`} className={styles.helpSmsLink}>
          Need help? Text us.
        </a>
      )}
      {/* <div className={styles.botton}>{buttonText}</div> */}
    </div>
  )
}
